// extracted by mini-css-extract-plugin
module.exports = {"card":"EmailSignUp_card__FPZX5","heading":"EmailSignUp_heading__K74YS","form":"EmailSignUp_form__kyY79","submit":"EmailSignUp_submit__6lMYx"};